module.exports = __webpack_public_path__ + "static/media/otherTrailer.7d9eda86.svg";